import SpotIncentive from "@/react/components/editors/incentive/spotIncentive/SpotIncentive.tsx";
import SpotIncentivePreview from "@/react/components/editors/incentive/spotIncentive/SpotIncentivePreview.tsx";

/**
 * Spot Incentive Editor Component
 * @param {Object} props
 * @param {Object} props.record - Editor record containing spotIncentive, selectedTask, and initialFileData
 * @param {Function} props.onClose - Callback to close the editor
 * @param {Object} props.editorInstance - Editor instance reference
 */
export const SpotIncentiveEditor = ({ record: editorRecord, onClose, editorInstance }) => {
  const { spotIncentive: record, selectedTask, initialFileData } = editorRecord;

  if (!record.isPhantom) {
    return (
      <SpotIncentivePreview
        data={record}
        editorInstance={editorInstance}
        onClose={onClose}
      />
    );
  }

  return (
    <SpotIncentive
      record={record}
      onClose={onClose}
      editorInstance={editorInstance}
      selectedTask={selectedTask}
      initialFileData={initialFileData}
    />
  );
};
